import type { MouseEvent } from "react";
import { useEffect, useState } from "react";

interface IUsePopperReturn {
  anchorEl: HTMLElement | null;
  hoverTrigger: (event: React.MouseEvent<HTMLElement>) => void;
  blurTrigger: () => void;
  hoverPopover: () => void;
  blurPopover: () => void;
  isPopoverOpen: boolean;
}

export function usePopper(): IUsePopperReturn {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isHoveringPopover, setIsHoveringPopover] = useState(false);
  const [isHoveringTrigger, setIsHoveringTrigger] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  useEffect(() => {
    setIsPopoverOpen(isHoveringPopover || isHoveringTrigger);
  }, [isHoveringPopover, isHoveringTrigger]);

  function hoverTrigger(event: MouseEvent<HTMLElement>): void {
    setAnchorEl(event.currentTarget);
    setIsHoveringTrigger(true);
  }

  function blurTrigger(): void {
    setIsHoveringTrigger(false);
  }

  function hoverPopover(): void {
    setIsHoveringPopover(true);
  }

  function blurPopover(): void {
    setIsHoveringPopover(false);
  }

  return {
    anchorEl,
    hoverTrigger,
    blurTrigger,
    hoverPopover,
    blurPopover,
    isPopoverOpen,
  };
}

export const popperModifiers = [
  {
    name: "flip",
    enabled: true,
    options: {
      altBoundary: true,
      rootBoundary: "document",
      padding: 8,
    },
  },
  {
    name: "preventOverflow",
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      rootBoundary: "document",
      padding: 8,
    },
  },
];
